import { Component, DoCheck } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../../shared/shared.service';
import { Constants } from '../../shared/Helpers/constants';
import { UserService } from 'src/app/_services';
import { PasswordRecover } from 'src/app/_models';
import { IUser, IUserDetailsRecoveryToken, IUserForgotPassDetails } from 'src/app/shared/interfaces';
import { Alert, AlertTypeEnum } from 'src/app/shared/Helpers/Alert';
import { HttpResponse } from '@angular/common/http';
import { HelperFunctions } from 'src/app/shared/Helpers/helperFunctions';
import { Buffer } from 'buffer';

@Component({
  selector: 'forgot-pwd-link',
  templateUrl: './forgot-pwd-link.component.html',
})
export class ForgotPwdLinkComponent implements DoCheck {
  public passwordResetForm: FormGroup;
  public type: string = 'password';
  public confType: string = 'password';
  public logoPath: string;
  private token: string;
  public securityPolicyDetails: IUserForgotPassDetails;
  public passwordCharNumber: number = 0;
  public upperCaseNo: number = 0;
  public lowerCaseNo: number = 0;
  public containsNo: number = 0;
  public specialCharNo: number = 0;
  public usernameChar: boolean = true;
  public passwordValidation: boolean = false;
  public user: IUser;
  public usernameContains: boolean = true;
  public customRulesValidation: boolean;
  public linkValidity: boolean ;
  public passwordContainsSpace: boolean = false;
  public passwordContainsNames: boolean = false;
  private afterResetRedirectUrl: string

  constructor(
    private _formBuilder: FormBuilder,
    private _userService: UserService,
    private _router: Router,
    private _activedRoute: ActivatedRoute,
    private _sharedService: SharedService
  ) {
    this.token = this._activedRoute.snapshot.paramMap.get('token');
    this.afterResetRedirectUrl = this._activedRoute.snapshot.queryParams?.redirectLink
    this.checkLinkExpire();
    // this.initForm();
  }

  ngDoCheck() {
    if (this._sharedService.loadedOrganisationByUrl.value) {
      if (this._sharedService.loginCustomisation.value != undefined && this._sharedService.loginCustomisation.value != null) {
        if (this._sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this._sharedService.LogoImage.value;
        }
        else {
          this.logoPath = Constants.logoPath;
        }
      }
      else {
        this.logoPath = Constants.logoPath;
      }
    }
    else {
      this.logoPath = Constants.logoPath;
    }
  }

  private initForm(): void {
    this._userService.getUserDetailsFromRecoveryToken(this.token).subscribe((res: HttpResponse<IUserDetailsRecoveryToken>) => {
      this.loadSecurityQuestionsFromIDAM(res.body.organisationId, res.body.username);
      this.passwordResetForm = this._formBuilder.group({
        username: ['', [Validators.required]],
        newPassword: ['', [Validators.required]],
        newPasswordConfirm: ['', [Validators.required]]
      });
    })
  }

  private loadSecurityQuestionsFromIDAM(orgId: string, username: string) {
    this._userService.getSecurityPolicyByOrganisation(orgId, username).subscribe({
      next: (res: HttpResponse<IUserForgotPassDetails>) => {
        this.securityPolicyDetails = res.body;
      }}
    )
  }

  public resetPasswordSubmit(): void {
    const recoveryEmail: any = this.passwordResetForm.value;
    const passwordRecover: PasswordRecover = {
      newPassword: recoveryEmail.newPassword,
      recoveryToken: this.token,
      username: recoveryEmail.username
    }

    this._userService.forgotPasswordChange(passwordRecover).subscribe({
      next: (res) => {
        if (res) {
          setTimeout(() => {
            localStorage.clear();
          }, 2000);
        }
        Alert.basicNotification(AlertTypeEnum.Success, "Reset password", "Password changed successfully.");
        if (this.afterResetRedirectUrl) {
          const decodedUrl = Buffer.from(this.afterResetRedirectUrl, 'base64').toString('utf8');

          window.location.replace(decodedUrl);
        } else {
          this._router.navigateByUrl('/login');
        }
      },
      error: (error) => {
          Alert.basicNotification(AlertTypeEnum.Error, "Reset password", error.error.detailedMessage);
      }
    })
  }

  public checkPasswordStrength(input: any) {
    const caseInsensitiveInput = input.toLowerCase();
    if (this.securityPolicyDetails != undefined) {
       this.passwordValidation = true;

      if (this.securityPolicyDetails.security.passwordUpperCaseRestriction) {
        this.upperCaseNo = 0;
        for (var i = 0; i < input.length; i++) {
          if (input[i] === input[i].toUpperCase() && input[i] !== input[i].toLowerCase()) {
            this.upperCaseNo++
          }
        }
        if (this.upperCaseNo < this.securityPolicyDetails.security?.passwordUpperCaseNo) {
          this.passwordValidation = false;
        }
      }

      if (this.securityPolicyDetails.security.usernameRestriction) {
        this.usernameChar = true;
        if (input.length > this.securityPolicyDetails.security.usernameCharacterNo || input.length == this.securityPolicyDetails.security.usernameCharacterNo) {
          if (this.securityPolicyDetails.firstname && this.securityPolicyDetails.firstname != "") {
            const firstname = this.securityPolicyDetails.firstname.split('').reduce((s, c) => { let l = s.length - 1; (s[l] && s[l].length < this.securityPolicyDetails.security.usernameCharacterNo) ? s[l] += c : s.push(c); return s; }, []);
            firstname.forEach(x => {
              if (x.length == this.securityPolicyDetails.security.usernameCharacterNo) {
                if (caseInsensitiveInput.includes(x)) {
                  this.usernameChar = false;
                  this.passwordValidation = false;
                }
              }
            })
          }
          if (this.securityPolicyDetails.middlename && this.securityPolicyDetails.middlename != "") {
            const middleName = this.securityPolicyDetails.middlename?.split('').reduce((s, c) => { let l = s.length - 1; (s[l] && s[l].length < this.securityPolicyDetails.security.usernameCharacterNo) ? s[l] += c : s.push(c); return s; }, []);
            middleName?.forEach(x => {
              if (x.length == this.securityPolicyDetails.security.usernameCharacterNo) {
                if (caseInsensitiveInput.includes(x)) {
                  this.usernameChar = false;
                  this.passwordValidation = false;
                }
              }
            })
          }
          if (this.securityPolicyDetails.lastname && this.securityPolicyDetails.lastname != "") {
            const lastName = this.securityPolicyDetails.lastname?.split('').reduce((s, c) => { let l = s.length - 1; (s[l] && s[l].length < this.securityPolicyDetails.security.usernameCharacterNo) ? s[l] += c : s.push(c); return s; }, []);
            lastName?.forEach(x => {
              if (x.length == this.securityPolicyDetails.security.usernameCharacterNo) {
                if (caseInsensitiveInput.includes(x)) {
                  this.usernameChar = false;
                  this.passwordValidation = false;
                }
              }
            })
          }
        }
        if (caseInsensitiveInput.includes(this.securityPolicyDetails.username?.toLowerCase()) || caseInsensitiveInput == this.securityPolicyDetails.username?.toLowerCase()) {
          this.usernameContains = false;
          this.passwordValidation = false;
        } else {
          this.usernameContains = true;
        }
      }

      if (this.securityPolicyDetails.security.passwordLowerCaseRestriction) {
        this.lowerCaseNo = 0;
        for (var i = 0; i < input.length; i++) {
          if (input[i] !== input[i].toUpperCase() && input[i] === input[i].toLowerCase()) {
            this.lowerCaseNo++
          }
        }
        if (this.lowerCaseNo < this.securityPolicyDetails.security?.passwordLowerCaseNo) {
          this.passwordValidation = false;
        }
      }
      if (this.securityPolicyDetails.security?.passwordNumberRestriction) {
        this.containsNo = 0;
        for (var i = 0; i < input.length; i++) {
          if (/[0-9]/.test(input[i])) {
            this.containsNo++;
          }
        }
        if (this.containsNo < this.securityPolicyDetails.security?.passwordNumberNo) {
          this.passwordValidation = false;
        }
      }

      if (this.securityPolicyDetails.security.passwordSpecialCharRestriction) {
        var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-="
        this.specialCharNo = 0;
        for (var i = 0; i < input.length; i++) {
          if (specialChars.indexOf(input[i]) != -1) {
            this.specialCharNo++
          }
        }
        if (this.specialCharNo < this.securityPolicyDetails.security?.passwordSpecialCharNo) {
          this.passwordValidation = false;
        }
      }
      this.passwordCharNumber = input.length;
      if (this.passwordCharNumber < this.securityPolicyDetails.security.passwordMinCharacterNo) {
        this.passwordValidation = false;
      }

      if (this.securityPolicyDetails.security?.customRules?.length > 0) {
        var regexNotFound = 0;
        for (var i = 0; i < this.securityPolicyDetails.security?.customRules.length; i++) {
          if (!this.passwordResetForm.controls['newPassword'].value.match(this.securityPolicyDetails.security?.customRules[i].regularExpression))
            regexNotFound++
        }
        if (regexNotFound > 0) {
          this.customRulesValidation =  false;
          this.passwordValidation = false;
        }
        else {
          this.customRulesValidation = true;
        }
        if (this.securityPolicyDetails.security.passwordSpaceRestriction) {
          this.passwordContainsSpace = false;
          if (input.indexOf(' ') > 0) {
            this.passwordContainsSpace = true;
            this.passwordValidation = false;
          }
        }
        if (this.securityPolicyDetails.security.passwordUsersNameRestriction) {
          this.passwordContainsNames = false;
          if (this.securityPolicyDetails.security?.minUsersNameCharacters == 0) {
            if (caseInsensitiveInput.includes(this.securityPolicyDetails.middlename) || caseInsensitiveInput.includes(this.securityPolicyDetails.firstname) || caseInsensitiveInput.includes(this.securityPolicyDetails.lastname) || caseInsensitiveInput.includes(this.securityPolicyDetails.displayname)) {
              this.passwordValidation = false;
              this.passwordContainsNames = true;
            }
          }
          if (this.securityPolicyDetails.security?.minUsersNameCharacters! > 0) {
            //check if length of firstName or surname or displayname or middleName is >= to this property value; if so => check if those words are used for password
            if (input.length >= this.securityPolicyDetails.security?.minUsersNameCharacters) {
              let fieldsToCheck: string[] = [this.securityPolicyDetails.firstname, this.securityPolicyDetails.displayname, this.securityPolicyDetails.lastname, this.securityPolicyDetails.middlename]

              var containsUsername = HelperFunctions.containsSubstringInList(caseInsensitiveInput, this.securityPolicyDetails.security?.minUsersNameCharacters + 1, fieldsToCheck)
              this.passwordValidation = containsUsername == true ? false : this.passwordValidation;
              this.passwordContainsNames = containsUsername;
            }
          }
        }
      }
    }
  }

  public tooglePasswordMode(type: string, isMain: boolean) {
    if (isMain) {
      this.type = type;
    } else {
      this.confType = type;
    }
  }

  public passwordsAreEqual(): boolean {
    const newPassword: string = this.passwordResetForm.controls['newPassword'].value
    const newPasswordConfirm: string = this.passwordResetForm.controls['newPasswordConfirm'].value

    if (newPassword === newPasswordConfirm) {
      return true;
    }
    return false;
  }

  public checkLinkExpire() {
    return this._userService.checkLinkExpire(this.token).subscribe((res: any)=>{
      this.linkValidity = res.valid;
      if(this.linkValidity){
        this.initForm();
      }
    })
  }

}

